import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { assetsRestCrudThunksForSupplier } from '../../thunks/assets_thunks';
import { EditPage } from '../edit_page/EditPage';
import SupplierAssetForm from '../supplier_asset_form/SupplierAssetForm';
import { goBack, goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import queryString from 'qs';
const style = require('./SupplierEditAssetPage.less');

class SupplierEditAssetPage extends React.Component<any, any> {
	state = {
		loading: true,
		assetDetail: {},
	};

	componentDidMount() {
		const { getAsset, match } = this.props;
		const assetId = match.params.id;
		getAsset(assetId).then((asset) => {
			this.setState({
				loading: false,
				assetDetail: asset,
			});
		});
	}

	render() {
		const { history, location } = this.props;

		//noinspection TypeScriptUnresolvedVariable
		return [
			<EditPage
				title="Edit Asset"
				formComponentProps={{
					formData: this.state.assetDetail,
					onSuccess: (rec) => {
						goBack(location, history, `/supplier/assets/detail/${rec.id}/details`);
					},
				}}
				fetching={this.state.loading}
				FormComponent={SupplierAssetForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		location: ownProps.location,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierEditAssetPage));
